import TnCSignUp from './TnCSignUp'
export default TnCSignUp
